import Api from '@/api/api';

class CommentsApi extends Api {
  constructor() {
    super('comments');
  }

  findByContentId(id) {
    return super.get(`content/${id}`);
  }

  like(id) {
    return this.request
      .post(this.getURL(`${id}/like`));
  }
}

export default new CommentsApi();
